import React from 'react';
import { Form } from '../Forms';
import { ProjectsConstructorFormControls } from './ProjectsConstructorFormControls';
import classes from './ProjectsConstructorForm.module.scss';

type RoleFormProps<T> = {
  formUid: string;
  children: React.ReactNode;
  handleCancel?: () => void;
  handleSubmit: (value: any) => void;
  initialValues: T;
  schema: any;
  isCancelButton?: boolean;
  withoutControls?: boolean;
};

export const ProjectsConstructorForm = <T,>({
  handleCancel,
  handleSubmit,
  formUid,
  initialValues,
  schema,
  children,
  isCancelButton,
  withoutControls,
}: RoleFormProps<T>) => {
  return (
    <Form.Formik<T>
      uid={formUid}
      i18nKeyPrefix="projects.createProject"
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <div className={classes.form}>
        {children}
        {!withoutControls && (
          <ProjectsConstructorFormControls isCancelButton={isCancelButton} onCancel={handleCancel} />
        )}
      </div>
    </Form.Formik>
  );
};
